<template>
  <div class="items-center min-h-screen w-full xl:p-32 md:p-10">
    <div class="md:flex w-full bg-white rounded shadow-lg">
      <div class="md:block xl:w-1/2 md:w-full barley-corn-bg-color py-10 px-5">
        <div class="flex">
          <div class="flex-shrink-0">
            <svg class="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
              aria-hidden="true">
              <path fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clip-rule="evenodd" />
            </svg>
          </div>
          <div class="ml-3">
            <div class="text-sm text-white">
              <p>
                <b>Agent Portal Instructions:</b>
                <br><br>
                <span class="text-md">Welcome to our Agent Portal!</span>
                <br>
                <ul class="list-decimal	 ml-10 mt-2 mb-2">
                  <li>
                    Before you use this portal, you will need to create an account. Please click the “Register Account” link. You will be prompted to enter a few key details including:
                    <ul class="list-disc ml-10 mt-2 mb-2">
                    <li> Your unique Authorization Code (provided to you by U.S. Legal)</li>
<li> Your ZIP (if multiple locations, please use the primary address ZIP code)</li>
<li> Email Address (must match what we have on file for you)</li>
</ul>
                  </li>
                  <br>
                  <li>
                    You will be prompted to create your own Username (must be your email address) and Password. Click Register. You will be sent an email with a confirmation code. The confirmation code will be entered on the next screen. Do not navigate away from this screen.
                  </li>
                  <br>
                  <li>
                    Enter the confirmation code that you received by email.
                  </li>
                  <br>
                  <li>
Sign in with the credentials that you just created. 
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full xl:w-1/2 md:w-full py-10 px-5 md:px-10">
        <div class="md:flex w-full">
          <div class="w-full py-3 px-5">
            <div v-if="isRegistered">
              <span class="float-right">First time accessing the agent portal?</span>
              <br>
              <a href="javascript:;" v-if="isRegistered" @click="toggleForm()"
                class="mt-2 cobalt-text-color inline-flex float-right text-xl">Register Account</a>
            </div>
            <div class="flex items-center">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"></path>
              </svg>
              <div class="text-right text-xl cobalt-text-color" v-if="!isRegistered">
                Register Account
              </div>
              <div class="text-right text-xl cobalt-text-color" v-if="isRegistered">
                Log In
              </div>

            </div>

            <form class="mt-5 space-y-6" @submit.prevent="logIn" novalidate>
              <div class="rounded-sm">
                <div class="flex flex-col" v-if="!isRegistered">
                  <text-input id="agent_number" label="Authorization Code"
                    :class="{ 'border-red-400': v$.form.agent_number.$error }" v-bind:value="form.agent_number"
                    @blur="v$.form.agent_number.$touch()"
                    v-on:keyup="form.agent_number = $event.target['value']"></text-input>
                  <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.agent_number.$errors"
                    :key="index">
                    <div v-if="error.$validator == 'required'">
                      {{ error.$message }}
                    </div>
                  </div>
                </div>
                <div class="flex flex-col mt-2" v-if="!isRegistered">
                  <text-input id="zip" label="ZIP (Primary address)" :class="{ 'border-red-400': v$.form.zip.$error }"
                    v-bind:value="form.zip" @blur="v$.form.zip.$touch()"
                    v-on:keyup="form.zip = $event.target['value']"></text-input>
                  <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.zip.$errors" :key="index">
                    <div v-if="error.$validator == 'required'">
                      {{ error.$message }}
                    </div>
                  </div>
                </div>
                <div class="flex flex-col mt-2" v-if="!isRegistered">
                  <text-input id="email" label="Email"
                    :class="{ 'border-red-400': v$.form.email.$error }" v-bind:value="form.email"
                    @blur="v$.form.email.$touch()" v-on:keyup="form.email = $event.target['value']"></text-input>
                  <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.email.$errors" :key="index">
                    <div v-if="error.$validator == 'required'">
                      {{ error.$message }}
                    </div>
                    <div v-if="error.$validator == 'email'">
                      Please enter valid email
                    </div>
                  </div>
                  <div class="text-xs">
                    <a href="javascript:;" @click="toggleForm()"
                      class="float-right mt-2 cobalt-text-color inline-flex">Account already registered?</a>
                  </div>
                </div>
                <div class="flex flex-col" v-if="isRegistered">
                  <text-input id="username"  label="Username" :class="{ 'border-red-400': v$.form.username.$error }"
                    v-bind:value="form.username" @blur="v$.form.username.$touch()"
                    v-on:keyup="form.username = $event.target['value']"></text-input>
                  <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.username.$errors" :key="index">
                    <div v-if="error.$validator == 'required'">
                      {{ error.$message }}
                    </div>
                  </div>
                </div>
                <div class="flex flex-col mt-2" v-if="isRegistered">
                  <text-input id="password" label="Password" :type="show ? 'password' : 'text'" showIcon="true"
                    showIcon1="true" @showHide="show = !show" :class="{ 'border-red-400': v$.form.password.$error }"
                    v-bind:value="form.password" v-on:keyup="form.password = $event.target['value']"></text-input>
                  <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.password.$errors" :key="index">
                    <div v-if="error.$validator == 'required'">
                      {{ error.$message }}
                    </div>
                  </div>
                  <div class="text-xs w-full">
                    <div class="w-full text-right">
                      <router-link to="/forgot-password" v-if="isRegistered"
                        class="mt-2 cobalt-text-color inline-flex">Forgot Password?</router-link>
                    </div>
                    <a href="javascript:;" v-if="!isRegistered" @click="toggleForm()"
                      class="mt-2 cobalt-text-color inline-flex">Password already registered?</a>
                  </div>
                </div>
              </div>
              <div>
                <button id="signin" type="submit"
                  class="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white cobalt-button-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-50"
                  aria-required="true">
                  <span class="absolute left-0 inset-y-0 flex items-center pl-3">
                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z">
                      </path>
                    </svg>
                  </span>
                  <span v-if="isRegistered">Log In</span>
                  <span v-if="!isRegistered">Proceed</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import TextInput from "../Layout/Form/TextInput.vue";
// import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { helpers } from "vuelidate/lib/validators";
const email = helpers.regex("email",/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/);
export default {
  name: "LogIn",
  components: {
    TextInput,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data: function () {
    return {
      show: true,
      isRegistered: Boolean,
      form: { password: "" },
    };
  },
  validations() {
    if (this.isRegistered) {
      return {
        form: {
          username: {
            required,
          },
          password: {
            required,
          },
        },
      };
    } else {
      return {
        form: {
          zip: {
            required,
          },
          agent_number: {
            required,
          },
          email: {
            required,
            email
          },
        },
      };
    }
  },
  mounted() {
    this.isRegistered = true;
  },
  methods: {
    logIn: function () {
      this.v$.form.$touch(this.v$.form.errors);
      console.log(this.v$.form);
      if (this.v$.form.$pending || this.v$.form.$error) return;
      this.form.is_registered = this.isRegistered;
      if (this.isRegistered) {
        this.$store.dispatch("loginAgent", this.form).then((result) => {
          localStorage.setItem("agent_data", JSON.stringify(result?.data?.data?.AuthenticationResult?.AccessToken));
          this.$store.dispatch("setAgentTkn");
          this.$store.dispatch("getAgentData").then((result1) => {
            console.log(result1)
            if(result1.data.length==1){
              localStorage.setItem("selected_agent",JSON.stringify(result1.data[0]));
              this.$store.dispatch("setSelectedAgent");
              this.$router.push("/home");
            }else{
              this.$router.push("/select-agent");
            }
          })
            .catch((error) => {
              this.$toast.error(error.message);
              this.$store.dispatch("logout");
              this.$router.push("/login");
            });
        })
          .catch((error) => {
            this.$toast.error(error);
            console.log(error)
          });
      } else {
        this.$store.dispatch("setupAgent", this.form).then((result) => {
          if (result?.data?.status == "unAuthorized") {
            document.getElementById("loader").classList.add("hidden");
            this.$toast.error(result.data.message);
            this.$store.dispatch("logout");
            this.$router.push("/login");
          } else {
            this.$router.push("/register");
          }
        })
          .catch((error) => {
            this.$toast.error(error);
            console.log(error)
          });
      }
    },
    toggleForm: function () {
      this.v$.$reset();
      this.form.password = null;
      this.form.agent_number = null;
      this.form.email = null;
      this.form.zip = null;
      this.form.username = null;
      this.isRegistered = !this.isRegistered;
    },
  },
};
</script>
